import _ from 'lodash';

export function qtStatus(quotation: any): string {
  if(!quotation) return '';
  let qtStatus = quotation.status;
  if(['Submitted Draft', 'Pending Revision', 'Open'].includes(quotation.status)) {
    const approvalVersion = _.get(quotation, 'approvalVersion', 0);
    if(approvalVersion > 1) {
      const formattedRevNo = approvalVersion < 11 ? `{rev0${approvalVersion - 1}}` : `{rev${approvalVersion - 1}}`;
      qtStatus = qtStatus + ` ${formattedRevNo}`;
    }  
  }
  const extendRequest = _.find(quotation.requests, (request: any) => ['Extend', 'Extend Quotation'].includes(request.type) && request.status == 'Pending');
  if(extendRequest) {
    qtStatus = qtStatus + ' (Extension Requested)';
  }
  const cancelRequest = _.find(quotation.requests, (request: any) => request.type == 'Cancel' && request.status == 'Pending');
  if(cancelRequest) {
    qtStatus = qtStatus + ' (Close Requested)';
  }
  const rejectRequest = _.find(quotation.requests, (request: any) => request.type == 'Reject' && request.status == 'Pending');
  if(rejectRequest) {
    qtStatus = qtStatus + ' (Reject Requested)';
  }
  return qtStatus;
}